import React, { Component } from 'react';
import Header from '../../components/Header';
import Contact from './Contact';
import Footer from './Footer';
import Copyright from './Copyright';
import {header, contact, footer, copyright} from './config';

class App extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {className, children} = this.props;
    return (
      <div className={className || null} style={{paddingTop: '60px'}}>
        <Header items={header} />
        {children}
        <Footer {...footer} />
        <Copyright {...copyright} />
        <Contact {...contact} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/routes/App/App.js